import React, { useEffect, useState } from 'react';
import { Button, Input, Card, Select } from '@alifd/next';
import { message } from 'antd';
import axios from 'axios';
import styles from './index.module.scss';
import client from '../../../../lib/feathers';

const BroadCastList = () => {
  const broadcastBox = client.service('broadcastBoxs');
  const [broadcastBoxData, setBroadcastBoxData] = useState([]);
  const [broadcastBoxList, setBroadcastBoxList] = useState([]);
  const [urgentMsg, setUrgentMsg] = useState('');
  useEffect(() => {
    (async () => {
      const res = await broadcastBox.find({});
      setBroadcastBoxData(
        res.data.map((item) => {
          const newItem = {
            label: item.name,
            value: item._id,
          };
          return newItem;
        })
      );
    })();
  }, [broadcastBox]);
  return (
    <>
      <Card free>
        <Card.Content>
          <div className={styles.householdBox}>
            <h2 className={styles.household}>選擇公播盒：</h2>
            <Select
              aria-label="tag mode"
              mode="tag"
              onChange={(value) => {
                setBroadcastBoxList(value);
              }}
              dataSource={broadcastBoxData}
              value={broadcastBoxList}
            />
          </div>
          <Input.TextArea
            className={styles.input}
            placeholder="請輸入緊急通知內容"
            aria-label="TextArea"
            maxLength={500}
            rows={6}
            hasLimitHint
            value={urgentMsg}
            onChange={(value) => {
              setUrgentMsg(value);
            }}
          />
          <Button
            type="primary"
            className={styles.emit}
            onClick={() => {
              const newRecord = {
                urgentMsg,
                broadcastArray: broadcastBoxList,
              };
              console.log(broadcastBoxList);
              axios('/ezcon/api/postUrgent', {
                method: 'POST',
                headers: {
                  authorization: window.localStorage['feathers-jwt'],
                },
                data: newRecord,
              })
                .then((res) => {
                  console.log(res);
                  setBroadcastBoxList([]);
                  setUrgentMsg('');
                  message.success('緊急通知發送成功');
                  // message.success('設定成功');
                  // setAddBroadcastDialog(false);
                })
                .catch((err) => {
                  console.log(err);
                });
            }}
          >
            送出
          </Button>
        </Card.Content>
      </Card>
    </>
  );
};

export default BroadCastList;
